<template>
    <div class="create-vehicle-page page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">New Listing</h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <vehicle-form ref="form"/>
        </div>
    </div>
</template>

<script>
    import VehicleForm from "@/components/main/vehicle/Form";

    export default {
        mixins: [

        ],
        components: {
            VehicleForm
        },
        data() {
            return {}
        },
        computed: {},
        mounted() {

        },
        beforeRouteLeave(to, from, next) {
            if (this.$refs.form.is_form_dirty) {
                this.$confirm('Any changes will be discard. Are you sure to leave this page?', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'info'
                }).then(() => {
                    next();
                });
            } else {
                next();
            }
        },
        methods: {},
    }
</script>

<style scoped>

</style>
